module.exports = __webpack_public_path__ + "media/the-wilton-area-is.e757142d.jpg";